import { render, staticRenderFns } from "./tgBalance.vue?vue&type=template&id=2befa514&scoped=true&"
import script from "./tgBalance.vue?vue&type=script&lang=js&"
export * from "./tgBalance.vue?vue&type=script&lang=js&"
import style0 from "./tgBalance.vue?vue&type=style&index=0&id=2befa514&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2befa514",
  null
  
)

export default component.exports